import { render } from "./vue-baberrage.vue?vue&type=template&id=48d62251"
import script from "./vue-baberrage.vue?vue&type=script&lang=js"
export * from "./vue-baberrage.vue?vue&type=script&lang=js"

import "./vue-baberrage.vue?vue&type=style&index=0&id=48d62251&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__